import { Checkbox, Dropdown, DropdownProps, List } from 'tea-component';
import React, { ReactNode, memo, useEffect, useRef } from 'react';
import { useSafeState } from 'ahooks';
interface Iprops<T = unknown> extends Partial<DropdownProps> {
  value: string | number;
  type?: 'list' | 'checkout';
  option: Array<{ value: T; text: string | ReactNode; }>;
  button: ReactNode;
  onChange: (...args: any[]) => void;
}
export const GptDropdown = memo(
  ({
    value,
    type = 'list',
    option,
    onChange,
    button,
    ...restProps
  }: Iprops) => {
    const [active, setActive] = useSafeState('');
    const feedbackRef = useRef(null);

    useEffect(() => {
      setActive(value);
    }, [setActive, value]);

    const handleOnclickCheckType = (value?: string[] | string) => {
      onChange?.(value);
    };
    const handleOnclickListType = (value: string) => {
      setActive(value);
      onChange?.(value);
    };
    return (
      <div ref={feedbackRef} >
        <Dropdown
          trigger="hover"
          clickClose={false}
          button={button}
          popupContainer={feedbackRef.current}
          appearance="pure"
          {...restProps}
        >
          {type === 'checkout' && (
            <Checkbox.Group
              value={value}
              onChange={handleOnclickCheckType}
              layout="column"
            >
              {option?.map((e, index) => (
                <Checkbox name={e.value} key={index} value={e?.text}>
                  {e.text}
                </Checkbox>
              ))}
            </Checkbox.Group>
          )}
          {type === 'list' && (
            <List type="option">
              {option?.map((e, i) => (
                <List.Item
                  key={i}
                  selected={e.value === active}
                  onClick={() => handleOnclickListType(e.value)}
                >
                  {e.text}
                </List.Item>
              ))}
            </List>
          )}
        </Dropdown>
      </div>
    );
  },
);
